import React, { memo, useCallback, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { BodyContainer, StyledMenuContainer } from "../SlideMenu.styles";
import MenuItem from "./MenuItem";

function MenuBody({ appUIModel, grantedMenuItems }) {
  const params = useParams();
  const { pathname } = useLocation();
  const { t, navigate, windowWidth, toggleMenu } = appUIModel;

  const [expand, setExpand] = useState("");

  const changeExpand = useCallback((data) => setExpand(data), []);

  const navigatePath = (path) => {
    if (!path) {
      return;
    }
    navigate(path);
    if (windowWidth <= 980) {
      toggleMenu(false);
    }
  };

  return (
    <BodyContainer>
      <StyledMenuContainer>
        {grantedMenuItems.map((item) => (
          <MenuItem
            t={t}
            key={item.name}
            item={item}
            expand={expand === item.name}
            changeExpand={changeExpand}
            navigatePath={navigatePath}
            checkFocusPath={(inputPath, isParent = false) => {
              if (!pathname) {
                return false;
              }

              const childrenPath =
                Array.isArray(item.children) && item.children.length > 0
                  ? item.children?.map((e) => e?.path)
                  : [];

              if (params["*"]) {
                const removeParamsPath = pathname.replace(
                  `/${params["*"]}`,
                  "",
                );

                if (!removeParamsPath) {
                  return false;
                }

                return (
                  removeParamsPath === inputPath ||
                  (isParent ? childrenPath.includes(removeParamsPath) : false)
                );
              }

              return (
                pathname === inputPath ||
                (isParent ? childrenPath.includes(pathname) : false)
              );
            }}
          />
        ))}
      </StyledMenuContainer>
    </BodyContainer>
  );
}

export default memo(MenuBody);
